module.exports = __webpack_public_path__ + "static/images/icon-armani.359da2d407fa52f1e34ffe34f22a88ed.svg";